<template>
  <img
    v-if="src"
    :src="src"
    :alt="nameShortcut"
    :style="style"
    class="base-avatar"
    v-on="$listeners"
  >
  <div
    v-else
    :style="style"
    class="base-avatar"
    v-on="$listeners"
  >
    <span v-if="placeholderName">{{ nameShortcut }}</span>
    <BaseSvg v-else :name="icon" :width="iconWidth || iconSize" :height="iconHeight || iconSize" />
  </div>
</template>

<script>
export default {
  name: 'BaseAvatar',
  props: {
    tile: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      default: '',
    },
    placeholderName: {
      type: String,
      default: null,
    },
    size: {
      type: [String, Number],
      default: 5,
    },
    color: {
      type: String,
      default: '#9c9bb6',
    },
    fontSize: {
      type: String,
      default: '1.6',
    },
    contain: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    iconWidth: {
      type: String,
      default: null,
    },
    iconHeight: {
      type: String,
      default: null,
    },
  },
  computed: {
    nameShortcut() {
      try {
        const [firstName, lastName] = this.placeholderName.split(' ');
        return firstName[0] || 'U' + (lastName?.[0] || '');
      } catch {
        throw new Error('Invalid placeholder name');
      }
    },
    iconSize() {
      return `calc(${this.size}rem * 0.5)`;
    },
    style() {
      const size = this.size + 'rem';
      return {
        width: size,
        minWidth: size,
        height: size,
        minHeight: size,
        borderRadius: this.tile ? '' : '50%',
        backgroundColor: this.color,
        fontSize: this.fontSize + 'rem',
        objectFit: this.contain ? 'contain' : 'cover',
      };
    },
  },
};
</script>
